<template>
  <div class="home">

  </div>
</template>

<script setup lang="ts">
import router from '@/router';
import { onMounted } from 'vue';

onMounted(() => {
  router.push({path: 'dashboard/info'})
})
</script>
